import { module } from 'modujs';
import { Swiper, Pagination } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.pagination = this.$('pagination')[0];

        this.carousel = new Swiper(this.el, {
            modules: [
                Pagination,
            ],
            speed: 450,
            loop: false,
            slideToClickedSlide: true,
            grabCursor: true,
            spaceBetween: '4%',
            pagination: {
                el: this.pagination,
                type: 'bullets',
                clickable: true
            }
        });
    }

    destroy() {
        if (this.carousel && this.carousel.destroy) {
            this.carousel.destroy();
        }
    }
}
